import store from "@/store";
import * as _core from "./coreService";
import * as _config from "@/config";
import * as _utility from "@/utility";
import dayjs from "dayjs";

export function deleteProject(projectId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "DeleteProject/";
    let data = { projectId: projectId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function deleteArea(areaId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "DeleteArea/";
    let data = { areaId: areaId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function deleteClient(clientId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "DeleteClient/";
    let data = { clientId: clientId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function deleteDivision(divisionId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "DeleteDivision/";
    let data = { divisionId: divisionId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function deleteEmployeeProjectLinks(projectIds) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "DeleteEmployeeProjectLinks/";
    let employeeId = store.state.user.id;
    let data = { employeeId: employeeId, projectIds: projectIds };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function deleteDefaultProjectLinks(projectIds) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "DeleteDefaultProjectLinks/";
    let employeeId = store.state.user.id;
    let data = { employeeId: employeeId, projectIds: projectIds };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function deleteAreaProjectLink(areaId, projectId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "DeleteAreaProjectLink/";
    let employeeId = store.state.user.id;
    let data = { employeeId: employeeId, areaId: areaId, projectId: projectId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function deleteTaskAreaProjectLink(taskId, areaId, projectIds) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "DeleteTaskAreaProjectLink/";
    let employeeId = store.state.user.id;
    let data = { employeeId: employeeId, taskId: taskId, areaId: areaId, projectId: projectIds };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function deleteEmployeeTfsInfo(tfsId, employeeId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "DeleteEmployeeTfsInfo/";
    let data = { pK_TfsServer: tfsId, EmployeeId: employeeId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}
export function deleteEmployeeXManager(employeeManagerId, employeeId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "DeleteEmployeeXManager/";
    let data = { employeeManagerId: employeeManagerId,employeeId:employeeId};
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function deleteExpenses(expenseIds) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "DeleteExpenses/";
    let data = { expenseIds: expenseIds };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function deleteTask(taskId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "DeleteTask/";
    let data = { taskId: taskId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function deleteTickets(ticketIds) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "DeleteTickets/";
    let data = { ticketIds: ticketIds };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getAreas(projectId, excludeInactive) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetAreas/";
    let data = { projectId: projectId, excludeInactive: excludeInactive };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getEmployee(id) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetEmployee/";
    let data = { employeeId: id };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getEmployeeTicketsReport(employeeId, startDate, endDate) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetEmployeeTicketsReport/";
    let data = { EmployeeId: employeeId, StartDate: startDate, EndDate: endDate };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getEmployeeProjectReport(employeeId, startDate, endDate) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetEmployeeProjectReport/";
    let data = { EmployeeId: employeeId, StartDate: startDate, EndDate: endDate };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}
export function getLastTwoWeeksTotals(employeeId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetLastTwoWeeksTotals/";
    let data = { EmployeeId: employeeId};
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getEmployeeWorkItemReport(employeeId, startDate, endDate) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetEmployeeWorkItemReport/";
    let data = { EmployeeId: employeeId, StartDate: startDate, EndDate: endDate };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getEmployeePTOHoursReport(employeeId,year) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetEmployeePTOHoursReport/";
    let data = {EmployeeId:employeeId, Year:year};
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getEmployeeTicketsForDateRange(employeeId, startDate, endDate) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetEmployeeTicketsForDateRange/";
    let data = { EmployeeId: employeeId, StartDate: startDate, EndDate: endDate };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}


export function getTicketsForDateRangeAndProject(projectId, startDate, endDate) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetTicketsForDateRangeAndProject/";
    let data = { ProjectId: projectId, StartDate: startDate, EndDate: endDate };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}
    
export function getEmployeeWorkedOvertimeReport(startDate, endDate) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetEmployeesWorkedOvertimeReport/";
    let data = { StartDate: startDate, EndDate: endDate };

    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}
export function getDivisions() {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetDivisions/";
    let data = {};
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getClients(active) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetClients/";
    let data = { active: active };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getEmployees(includeDisabled) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetEmployees/";
    let data = { includeDisabled: includeDisabled };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getManager(id) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetManager/";
    let data = { managerId: id };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getManagers(clientId,includeInactive) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetManagers/";
    let data = { clientId: clientId,includeInactive: includeInactive };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getEmployeeManagers(employeeId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetEmployeeManagers/";
    let data = { employeeId: employeeId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getManagerEmployees(managerId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetManagerEmployees/";
    let data = { managerId: managerId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getItems() {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetItems/";
    let data = { };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getSelectedItem(id) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetSelectedItem/";
    let data = {listId: id };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getWorkItemDetail(projectId, workItemNumber) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetWorkItemDetail/";
    let data = { projectId: projectId, workItemNumber: workItemNumber };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getProjects(includeHidden, includeInactive) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetProjects/";
    let data = { includeHidden: includeHidden, includeInactive: includeInactive };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getTasks(areaId, projectId, excludeInactive) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetTasks/";
    let data = { areaId: areaId, projectId: projectId, excludeInactive: excludeInactive };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getTfsServerOptions() {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetTfsServerOptions/";
    let data = {};
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getTickets(employeeId = null) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetTickets/";
    let data = { EmployeeId: employeeId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getTicketsForStaffing(employeeId = null,startDate) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetTicketsForStaffing/";
    let data = { EmployeeId: employeeId,StartDate:startDate };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getEmployeeProjectTotals(employeeId = null,projectName) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetEmployeeProjectTotals/";
    let data = { EmployeeId: employeeId, projectName: projectName };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getExpenses(employeeId = null) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetExpenses/";
    let data = { EmployeeId: employeeId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getTicketForEdit(ticketId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetTicketForEdit/";
    let data = { ticketId: ticketId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getExpenseForEdit(expenseId, employeeId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetExpenseForEdit/";
    let data = { expenseId: expenseId,employeeId:employeeId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getMileage(expenseDate) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetMileage/";
    let data = { expenseDate: expenseDate };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getMenu() {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetMenu/";
    let data = {  };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function refreshCache(forceLoad) {
  if (!forceLoad) forceLoad = false;
  return new Promise((resolve) => {
    let loadCache = false;
    let cacheDate = _utility.retrieveSearch("cacheDate");
    //console.log("clockworkService|refreshCache|cacheDate: ", cacheDate);
    if (cacheDate) {
      let now = dayjs();
      let diff = now.diff(dayjs(cacheDate), "hours");
      if (diff > 24) loadCache = true;
    } else loadCache = true;

    if (!loadCache && !forceLoad) return resolve({ success: true });

    getEmployees(true).then((response) => {
      if (response.success) {
        _utility.storeSearch("employees", JSON.stringify(response.employees), false);
      }
    });
    getProjects(true).then((response) => {
      if (response.success) {
        _utility.storeSearch("projects", JSON.stringify(response.projects), false);
        resolve({ success: true });
      }
    });
    getClients(true).then((response) => {
      if (response.success) {
        _utility.storeSearch("clients", JSON.stringify(response.clients), false);
      }
    });
    _utility.storeSearch("cacheDate", dayjs().format("YYYY-MM-DD HH:mm:ss"), false);
  });
}

export function saveEmployee(employee) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveEmployee/";
    let data = { employee: employee };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveEmployeeHoursOverride(endDateOverride,employeeId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveEmployeeHoursOverride/";
    let data = {endDateOverride: endDateOverride, employeeId: employeeId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveManager(manager) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveManager/";
    let data = { manager: manager };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}
export function saveEmployeeXManager(employeeXManager) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveEmployeeXManager/";
    let data = { employeeXManager: employeeXManager };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveEmployeeTfsInfo(data) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveEmployeeTfsInfo/";
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveArea(data) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveArea/";
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveClient(data) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveClient/";
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveDivision(data) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveDivision/";
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveProject(data) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveProject/";
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function SaveNewProjectFromExistingProject(data) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveNewProjectFromExistingProject/";
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveTask(data) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveTask/";
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}
export function saveExpense(form) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveExpense/";
    let data = { expense: form };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveTicket(form) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveTicket/";
    let data = { ticket: form };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveCopyOfTicketToday(ticketIds ,employeeId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "saveTicketCopyToToday/";
    let data = { ticketIds: ticketIds, employeeId: employeeId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveTicketCopyForWeek(employeeId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveTicketCopyForWeek/";
    let data = { employeeId: employeeId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function getTicketsFromImport(documentId) {
    return new Promise((resolve) => {
      let url = _config.urlClockworkService + "GetTicketsFromImport/";
      let data = { documentId: documentId };
      _core.fetchPost(url, data, true).then((response) => {
        resolve(response);
      });
    });
  }

export function saveTicketsFromImport(Tickets) {
    return new Promise((resolve) => {
      let url = _config.urlClockworkService + "SaveTicketsFromImport/";
      let data = { Tickets: Tickets };
      _core.fetchPost(url, data, true).then((response) => {
        resolve(response);
      });
    });
  }

export function getLastDayTicketForStaffing(employeeId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "GetLastDayTicketForStaffing/";
    let data = { employeeId: employeeId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveEmployeeProjectLinks(projectIds) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveEmployeeProjectLinks/";
    let employeeId = store.state.user.id;
    let data = { employeeId: employeeId, projectIds: projectIds };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveDefaultProjectLinks(projectIds) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "saveDefaultProjectLinks/";
    let employeeId = store.state.user.id;
    let data = { employeeId: employeeId, projectIds: projectIds };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveAreaProjectLink(areaId, projectId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveAreaProjectLink/";
    let data = { areaId: areaId, projectId: projectId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function saveTaskAreaProjectLink(taskId, areaId, projectId) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SaveTaskAreaProjectLink/";
    let data = { taskId: taskId, areaId: areaId, projectId: projectId };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function submitExpenses(expenseIds) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SubmitExpenses/";
    let data = { expenseIds: expenseIds };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}

export function submitTickets(ticketIds) {
  return new Promise((resolve) => {
    let url = _config.urlClockworkService + "SubmitTickets/";
    let data = { ticketIds: ticketIds };
    _core.fetchPost(url, data, true).then((response) => {
      resolve(response);
    });
  });
}
